<template>
<a-layout :style="{ background: '#fff', margin: '0 40px'}">
  <a-layout-sider width="280" style="background: #fff">
    <left-tree
      :gData="gData"
      :defaultSelectedKeys="defaultSelectedKeys"
      :defaultExpandedKeys="defaultExpandedKeys"
      @selectKey="changeApi"></left-tree>
  </a-layout-sider>
  <a-divider type="vertical" style="height: initial;margin-top: 8px" />
  <a-layout>
    <a-layout-content
      :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">
      <!-- <router-view/> -->
      <document-form v-if="documentType"></document-form>
      <markdown v-else :documentData="documentData"></markdown>
    </a-layout-content>
  </a-layout>
</a-layout>
</template>

<script>
import LeftTree from '@/components/document/LeftTree.vue';
import DocumentForm from '@/views/document/DocumentForm.vue';
import Markdown from '@/views/document/Markdown.vue';
import marked from 'marked';
import { Divider } from 'ant-design-vue';
import { getCategory, getDocumentById } from '@/api/document';
import hljs from 'highlight.js';
import 'highlight.js/styles/xcode.css';

export default {
  name: 'Document',
  components: {
    LeftTree,
    'a-divider': Divider,
    DocumentForm,
    Markdown,
  },
  props: {},
  data() {
    return {
      gData: [],
      defaultExpandedKeys: [],
      defaultSelectedKeys: [],
      documentType: 0,
      documentData: {},
      apiId: '',
    };
  },
  watch: {},
  computed: {},
  methods: {
    changeApi(key) {
      this.apiId = key;
      this.getDocumentData();
    },
    getCategory() {
      getCategory().then((res) => {
        if (res.length > 0) {
          this.gData = res;
          const parentId = res[0].key;
          let currentId = '';
          this.defaultExpandedKeys.push(parentId);
          if (res[0].children.length > 0) {
            currentId = res[0].children[0].key;
          } else {
            currentId = parentId;
          }
          this.defaultSelectedKeys.push(currentId);
          this.apiId = currentId;
          this.getDocumentData();
        }
      }).catch((err) => {
        this.$message.error(err.message);
      });
    },
    getDocumentData() {
      if (this.apiId === '5ea09885b0e446a2947f0088b88d4e20') {
        this.documentType = 0;
      } else {
        this.documentType = 1;
        return;
      }
      const params = this.apiId;
      getDocumentById(params).then((res) => {
        marked.setOptions({
          renderer: new marked.Renderer(),
          highlight(code) {
            return hljs.highlightAuto(code).value;
          },
          pedantic: false,
          gfm: true,
          tables: true,
          breaks: false,
          sanitize: false,
          smartLists: true,
          smartypants: false,
          xhtml: false,
        });
        if (res.content) {
          // eslint-disable-next-line
          res.content = marked(res.content);
        }
        this.documentData = res;
        console.log(res);
      }).catch((err) => {
        this.$message.error(err.message);
      });
    },
  },
  created() {
    this.getCategory();
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
</style>
